import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { IEquipmentBrand } from "@app/shared/data-access/src/lib/resource-management/models/equipment";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";

export class EquipmentBrandConfig implements IBaseConfig {
  version: number = 1;
  dicType = ResourceManagementEndpoints.EquipmentBrand;
  isCrudByModal = true;
  title = "dicTable.equipmentBrands";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "sortOrder",
      title: "dicTable.sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IEquipmentBrand[]> = {
    showDefaultActions: true,
    tableColumns: "44px auto auto",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
    ],
  };
}
